import RxBlobImageViewer from "./RxBlobImageViewer";

export default RxBlobImageViewer;
